import selectInput from './selectInput.vue'
export default selectInput